export class TypedStorage {
  public static removeItem(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      // logError(error as Error)
    }
  }

  public static getString(key: string): string | null {
    try {
      return localStorage.getItem(key)
    } catch (ex) {
      return null
    }
  }

  public static setItem<T>(key: string, value: T | string): void {
    try {
      const data: string = typeof value === 'object' ? JSON.stringify(value) : (value as string)

      localStorage.setItem(key, data)
    } catch (error) {
      // logError(error as Error)
    }
  }
}
